import { render, staticRenderFns } from "./filogix-page-loader.vue?vue&type=template&id=3d43718a"
import script from "./filogix-page-loader.vue?vue&type=script&lang=js"
export * from "./filogix-page-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports